import { z } from "@msuite/utils/lib/zod";
import { defineQuery } from "@rocicorp/zero";
import { zql } from "../zql";

/**
 * One video, for the block that embeds it. Scoped by the caller's organisation like every other
 * query here — row level security does not apply on the sync path, so the clause is the scope.
 *
 * There is no list query and there should not be: a video is only ever reached through the page
 * that names it, and a query that could enumerate an organisation's videos would hand out more
 * than any page does.
 */
export const videoQueries = {
	byId: defineQuery(
		z.object({
			videoId: z.uuid(),
		}),
		({ args, ctx }) => {
			return zql.videos.where("id", args.videoId).where("orgId", "=", ctx.orgId).one();
		},
	),
};
